module.exports = __webpack_public_path__ + "static/media/ak_logo.d0fca390.png";